import { useParams } from 'next/navigation';
import { useMemo } from 'react';
import { ellipsis } from '@diritto/common/utils/string';
import { useGetRelayRollingQuery } from 'queries/relay/useGetRelayRollingQuery';
import { configure } from 'utils/configure';
import { getFullUrl } from 'utils/url';

export const RollingHeader = () => {
  const params = useParams();
  const rollingId = Number(params?.rollingId);
  const { data } = useGetRelayRollingQuery(Number(rollingId), true);

  const rolling = data?.rolling;
  const profile = rolling && data?.profiles[rolling.profileId];

  const openImageUrl = `${configure.dynamicCdnPublicUrl}/rollings/og?rollingId=${rolling?.id}&updatedAt=${
    rolling && new Date(rolling.updatedAt).getTime()
  }`;
  const url = useMemo(() => getFullUrl(`/rollings/${rolling?.id}`), [rolling?.id]);

  const titleAndAuthorName = `${rolling?.title ? `${rolling.title} - ` : ''}${profile?.nickname ?? ''}`;
  // 80 자를 넘으면 검색엔진에 반영이 잘 안된다.
  const ogTitle = useMemo(() => ellipsis(titleAndAuthorName, 80), [titleAndAuthorName]);
  const description = useMemo(
    () => (rolling?.description ? ellipsis(rolling.description, 80) : ''),
    [rolling?.description],
  );

  const title = `${titleAndAuthorName} | 디리토`;

  return (
    <>
      <title>{title}</title>
      <meta property="og:type" content="website" key="type" />
      <meta property="og:title" content={ogTitle} key="title" />
      <meta property="og:image" content={openImageUrl} key="image" />
      <meta property="og:image:url" content={openImageUrl} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:description" content={description} key="description" />
      <meta property="og:url" content={url} key="url" />
      <meta property="og:site_name" content="디리토" key="site_name" />
      <meta property="twitter:image" content={openImageUrl} key="twitter:image" />
      <meta property="twitter:card" content="summary_large_image" key="twitter:card" />
      <meta property="twitter:site" content="@diritto_kr" key="twitter:site" />
      <meta property="twitter:title" content={ogTitle} key="twitter:title" />
      <meta property="twitter:description" content={description} key="twitter:description" />
      <link type="image/jpg" href={openImageUrl} />
      <link rel="canonical" href={url} />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'NewsArticle',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://google.com/article',
            },
            headline: titleAndAuthorName,
            image: [openImageUrl],
            url,
            description,
          }),
        }}
      />
    </>
  );
};
